import {
  Database,
  GitCompare,
  Layers,
  Package,
  ShieldCheck,
  Warehouse,
} from 'lucide-react';

export const PIPELINE_ACTIVE = new Set(['running', 'queued', 'pending', 'cancelling']);

export const PIPELINE_STEP_ICONS = {
  ahri_data_sync: Database,
  product_data_sync: Package,
  inventory_sync: Warehouse,
  product_mapping: GitCompare,
  attribute_mapping: Layers,
  data_quality: ShieldCheck,
};

export const PIPELINE_PHASES = [
  {
    id: 'ingest',
    title: 'Ingestion & catalog',
    subtitle: 'AHRI GraphQL, product index, then data quality on the catalog',
    stepIds: ['ahri_data_sync', 'product_data_sync', 'data_quality'],
  },
  {
    id: 'mapping',
    title: 'Inventory & mapping',
    subtitle: 'Warehouse feeds, AHRI ↔ product matching, and attribute sync',
    stepIds: ['inventory_sync', 'product_mapping', 'attribute_mapping'],
  },
];

export function pipelineNodeStatusClass(status) {
  const normalized = String(status || 'idle').toLowerCase();
  if (PIPELINE_ACTIVE.has(normalized)) return 'ahri-dash-pipeline__node--running';
  if (normalized === 'completed') return 'ahri-dash-pipeline__node--completed';
  if (normalized === 'failed' || normalized === 'error') return 'ahri-dash-pipeline__node--failed';
  if (normalized === 'cancelled' || normalized === 'canceled') return 'ahri-dash-pipeline__node--cancelled';
  return 'ahri-dash-pipeline__node--idle';
}
